export * from './asterisk-info.component';
